<div [class]="classes()" [style]="customStyles()"></div>
